import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, DatePicker, Modal, Popover, Select, Spin } from "antd";
import QueueAnim from "rc-queue-anim";
import moment from "moment";

import { companiesService, dashboardService, departmentsService } from "./../../redux/services";
import DonutChart from "../../components/Charts/DonutChart";
import LineStats from "../../components/Charts/LineStats";
import BarChartBankHours, { normalizeRange } from "../../components/Charts/BarChartBankHours";
import StatCard from "../../components/StatCard";
import { UIAvatarLabel } from "../../components";

const equipamento_labels = {
	"REP-P": "Aplicativo",
	"REP-C": "Equipamento",
};

const isAll = (v) => v === "" || v === "all" || v == null;

class Home extends Component {
	constructor(props) {
		super(props);

		const [inicio, fim] = normalizeRange([
			moment().subtract(30, "days").startOf("day"),
			moment().endOf("day"),
		]);

		this.state = {
			isLoading: true,

			// Filtros da página — propagados para todos os cards
			empresa: "all",
			departamento: "",
			inicio,
			fim,

			// Rascunho do popover de filtros
			filtrosOpen: false,
			empresaDraft: "all",
			departamentoDraft: "",

			empresas: [{ label: "Todas as empresas", value: "all" }],
			departamentos: [{ label: "Todos os Departamentos", value: "" }],
			loadingEmpresas: false,
			loadingDepartamentos: false,

			// Indicadores
			functionaios_limite: 0,
			funcionarios_ativos: 0,
			funcionarios_inativos: 0,
			total_funcionarios: 0,
			ultimo_registros: [],
			departamentos_ativos: 0,
			empresas_ativas: 0,
			aniversariantes_total: 0,
			aniversariantes_lista: [],
			total_feriados: 0,
			proximo_feriado: "—",
		};
	}

	componentDidMount() {
		this.fetchGetAll();
		this.fetchEmpresas();
	}

	fetchGetAll = () => {
		this.setState({
			isLoading: true,
		});

		dashboardService.getAll()
			.then((response) => {
				const { data } = response.data || {};

				this.setState({
					isLoading: false,
					functionaios_limite: data.functionaios_limite ?? 0,
					funcionarios_ativos: data.funcionarios_ativos ?? 0,
					funcionarios_inativos: data.funcionarios_inativos ?? 0,
					total_funcionarios: data.total_funcionarios ?? 0,
					ultimo_registros: data.ultimo_registros ?? [],
					departamentos_ativos: data.departamentos_ativos ?? 0,
					empresas_ativas: data.empresas_ativas ?? 0,
					aniversariantes_total: data.funcionarios_aniversariantes?.total ?? 0,
					aniversariantes_lista: data.funcionarios_aniversariantes?.lista ?? [],
					total_feriados: data.feriados?.total_feriados ?? 0,
					proximo_feriado: data.feriados?.proximo_feriado
						? moment(data.feriados.proximo_feriado).format("DD/MM/YYYY")
						: "—",
				});
			})
			.catch((data) => {
				this.setState({
					isLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchEmpresas = () => {
		this.setState({ loadingEmpresas: true });

		companiesService.getAll()
			.then((response) => {
				const brutos = response?.data?.data ?? response?.data ?? [];
				const lista = (Array.isArray(brutos) ? brutos : []).map((d) => ({
					label: d.nome,
					value: d.uuid,
				}));

				this.setState(({ empresas }) => ({
					empresas: [empresas[0], ...lista],
					loadingEmpresas: false,
				}));
			})
			.catch(() => this.setState({ loadingEmpresas: false }));
	};

	fetchDepartamentos = (empresaUuid) => {
		if (isAll(empresaUuid)) {
			this.setState({ departamentos: [{ label: "Todos os Departamentos", value: "" }] });
			return;
		}

		this.setState({ loadingDepartamentos: true });

		departmentsService.getAll({ empresa_uuid: empresaUuid })
			.then((response) => {
				const brutos = response?.data?.data ?? response?.data ?? [];
				const lista = (Array.isArray(brutos) ? brutos : []).map((d) => ({
					label: d.nome,
					value: d.uuid,
				}));

				this.setState({
					departamentos: [{ label: "Todos os Departamentos", value: "" }, ...lista],
					loadingDepartamentos: false,
				});
			})
			.catch(() => this.setState({ loadingDepartamentos: false }));
	};

	handleRangeChange = (vals) => {
		const [inicio, fim] = normalizeRange(vals);
		this.setState({ inicio, fim });
	};

	handleFiltrosToggle = (open) => {
		this.setState(({ empresa, departamento }) => ({
			filtrosOpen: open,
			...(open ? { empresaDraft: empresa, departamentoDraft: departamento } : {}),
		}));
	};

	handleFiltrosApply = () => {
		this.setState(({ empresaDraft, departamentoDraft }) => ({
			empresa: empresaDraft,
			departamento: departamentoDraft,
			filtrosOpen: false,
		}));
	};

	handleFiltrosClear = () => {
		this.setState({
			empresa: "all",
			departamento: "",
			empresaDraft: "all",
			departamentoDraft: "",
			filtrosOpen: false,
		});
	};

	greeting = () => {
		const hour = moment().hour();
		let day = "Bom dia";

		if (hour >= 19) {
			day = "Boa noite";
		}
		else if (hour >= 12) {
			day = "Boa tarde";
		}

		const firstName = String(this.props.user?.name ?? "").trim().split(" ")[0];

		return `${day}${firstName ? `, ${firstName}` : ""}!`;
	};

	renderFiltros() {
		const {
			filtrosOpen, empresaDraft, departamentoDraft,
			empresas, departamentos, loadingEmpresas, loadingDepartamentos,
		} = this.state;

		const filtrosAtivos = !isAll(this.state.empresa) || !isAll(this.state.departamento);

		const content = (
			<div className="byp-card__filter">
				<label>
					Empresa
					<Select
						value={empresaDraft}
						onChange={(v) => {
							this.setState({ empresaDraft: v, departamentoDraft: "" });
							this.fetchDepartamentos(v);
						}}
						options={empresas}
						size="middle"
						style={{ width: "100%" }}
						loading={loadingEmpresas}
					/>
				</label>
				<label>
					Departamento
					<Select
						value={departamentoDraft}
						onChange={(v) => this.setState({ departamentoDraft: v })}
						options={departamentos}
						size="middle"
						style={{ width: "100%" }}
						loading={loadingDepartamentos}
						disabled={isAll(empresaDraft)}
						notFoundContent="Nenhum departamento encontrado"
					/>
				</label>
				<div className="byp-card__filter-actions">
					<Button size="small" onClick={this.handleFiltrosClear}>Limpar</Button>
					<Button size="small" type="primary" onClick={this.handleFiltrosApply}>Aplicar</Button>
				</div>
			</div>
		);

		return (
			<Popover
				content={content}
				trigger="click"
				placement="bottomRight"
				visible={filtrosOpen}
				onVisibleChange={this.handleFiltrosToggle}
				overlayClassName="byp-card__filter-overlay"
			>
				<button type="button" className={`byp-dash__filters ${filtrosAtivos ? "is-active" : ""}`}>
					<i className="far fa-filter" /> Filtros
				</button>
			</Popover>
		);
	}

	renderRegistros() {
		const { ultimo_registros } = this.state;
		const podeVerHistorico = (this.props.permissions || []).includes("gestao.ponto-diario");

		return (
			<section className="byp-card byp-dash__records">
				<header className="byp-card__head">
					<div>
						<h3 className="byp-card__title">
							<span className="byp-card__title-icon"><i className="fad fa-fingerprint" /></span>
							Últimos Registros
							<button
								type="button"
								className="byp-dash__refresh"
								onClick={this.fetchGetAll}
								aria-label="Atualizar registros"
							>
								<i className="far fa-sync" />
							</button>
						</h3>
						<span className="byp-card__subtitle">Marcações das últimas 6 horas</span>
					</div>
					{podeVerHistorico && (
						<button
							type="button"
							className="byp-card__action"
							onClick={() => this.props.history.push("/gestao/dailypoint")}
						>
							Ver todas <i className="fas fa-chevron-right" />
						</button>
					)}
				</header>

				{ultimo_registros.length === 0 ? (
					<p className="byp-card__empty">Nenhum registro recente</p>
				) : (
					<ul className="byp-dash__records-list">
						{ultimo_registros.map((item, idx) => {
							const tipo = item.equipamento?.modelo === 'App' ? 'App' : item.equipamento?.tipo_equipamento;

							return (
								<li key={item.id ?? `${item.data}-${idx}`}>
									<UIAvatarLabel
										id={item.funcionario?.id}
										name={item.funcionario?.nome}
										avatar={item.funcionario?.avatar}
										showName={false}
									/>
									<div className="byp-dash__record-info">
										<span className="byp-dash__record-date">
											{moment(item.data).format("DD/MM/YYYY HH:mm[h]")}
										</span>
										<strong title={item.funcionario?.nome}>
											{item.funcionario?.nome ?? "—"}
										</strong>
										{tipo && (
											<span
												className={`byp-dash__record-tag byp-dash__record-tag--${tipo.toLowerCase()}`}
												title={equipamento_labels[tipo] ?? tipo}
											>
												{tipo}
											</span>
										)}
									</div>
								</li>
							);
						})}
					</ul>
				)}
			</section>
		);
	}

	render() {
		const {
			isLoading,
			functionaios_limite,
			funcionarios_ativos,
			departamentos_ativos,
			empresas_ativas,
			aniversariantes_total,
			aniversariantes_lista,
			total_feriados,
			proximo_feriado,
			empresa,
			departamento,
			inicio,
			fim,
		} = this.state;

		return (
			<QueueAnim className="site-content-inner page-home alternative-wrapper">
				<div className="page-content byp-dash" key="1">
					<header className="byp-dash__header">
						<div className="byp-dash__greeting">
							<h1>{this.greeting()} <span role="img" aria-label="olá">👋</span></h1>
							<p>Aqui está o resumo da sua operação.</p>
						</div>
						<div className="byp-dash__toolbar">
							<DatePicker.RangePicker
								value={[inicio, fim]}
								onChange={this.handleRangeChange}
								allowClear={false}
								format="DD/MM/YYYY"
								className="byp-dash__range"
								disabledDate={(current) => current && current.isAfter(moment().endOf("day"), "day")}
								ranges={{
									"Últimos 7 dias": [moment().subtract(6, "days").startOf("day"), moment().endOf("day")],
									"Últimos 15 dias": [moment().subtract(14, "days").startOf("day"), moment().endOf("day")],
									"Últimos 31 dias": [moment().subtract(30, "days").startOf("day"), moment().endOf("day")],
								}}
							/>
							{this.renderFiltros()}
						</div>
					</header>

					{isLoading ? (
						<div className="text-center">
							<Spin indicator={<i className="fad fa-spinner-third fa-spin fa-3x" />} />
						</div>
					) : (
						<Fragment>
							<div className="byp-dash__kpis">
								<StatCard
									value={empresas_ativas}
									title="Empresas"
									caption="Total cadastrado"
									icon="fad fa-building"
									tone="pink"
								/>
								<StatCard
									value={departamentos_ativos}
									title="Departamentos"
									caption="Total cadastrados"
									icon="fad fa-sitemap"
									tone="amber"
								/>
								<StatCard
									value={`${funcionarios_ativos}/${functionaios_limite}`}
									title="Funcionários"
									caption="Ativos / Limite do plano"
									icon="fad fa-users"
									tone="blue"
									progress={functionaios_limite ? funcionarios_ativos / functionaios_limite : null}
								/>
								<StatCard
									value={aniversariantes_total}
									title="Aniversariantes"
									caption="Hoje"
									icon="fad fa-birthday-cake"
									tone="green"
									lista={aniversariantes_lista}
									openOn="click"
								/>
								<StatCard
									value={total_feriados}
									title="Feriados"
									caption={`Próximo: ${proximo_feriado}`}
									icon="fad fa-calendar-star"
									tone="navy"
								/>
							</div>

							<div className="byp-dash__row byp-dash__row--main">
								<DonutChart empresa={empresa} departamento={departamento} />
								<LineStats empresa={empresa} base={funcionarios_ativos} />
							</div>

							<div className="byp-dash__row byp-dash__row--hours">
								<BarChartBankHours
									endPoint="banco_horas"
									title="Estatísticas de Banco de Horas"
									empresa={empresa}
									departamento={departamento}
									inicio={inicio}
									fim={fim}
								/>
								<BarChartBankHours
									endPoint="horas_extras"
									title="Estatísticas de Hora Extra"
									empresa={empresa}
									departamento={departamento}
									inicio={inicio}
									fim={fim}
								/>
							</div>

							{this.renderRegistros()}
						</Fragment>
					)}
				</div>
			</QueueAnim>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.auth.userData,
		permissions: state.auth.userData.permissions,
	};
};

export default connect(mapStateToProps)(Home);
